module.exports = __webpack_public_path__ + "img/allow.6b138f6.svg";